import React from 'react';
import Tailan from './sm_01';

const PageList = () => <Tailan />;

export default PageList;
